import { css } from '@emotion/react';
import { IonCol, IonGrid, IonImg, IonRouterLink, IonRow, IonText } from '@ionic/react';
import React from 'react';
import clarityLogo from '../../assets/img/clarity.png';
import * as commonCss from '../../styles/common';

interface PoweredByProps {
  sizePixels?: number;
  text?: string;
  fontSize?: number;
}

const PoweredBy: React.FC<PoweredByProps> = ({ sizePixels = 80, text = 'Powered by', fontSize }) => {
  const poweredByCss = {
    container: [
      css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: sizePixels,
        textAlign: 'center',
        padding: 0,
        margin: 0,
        'ion-col': {
          padding: 0,
        },
      }),
    ],
    text: [
      css({
        fontSize: fontSize ?? sizePixels / 10,
        // add white outline to text
        textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white,  1px 1px 0 white',
      }),
    ],
    img: [
      css({
        width: sizePixels,
        marginTop: -10,
        marginBottom: -5,
        filter: 'drop-shadow(1px 1px 0 white) drop-shadow(-1px -1px 0 white);',
      }),
    ],
    imgContainer: [
      css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }),
    ],
  };

  return (
    <IonGrid css={[poweredByCss.container, commonCss.noPadding]}>
      <IonRow>
        <IonCol>
          <IonText css={poweredByCss.text}>{text}</IonText>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol css={poweredByCss.imgContainer}>
          <IonRouterLink href="https://clarity.io" color="secondary" target="_blank">
            <IonImg src={clarityLogo} alt="Powered by" css={poweredByCss.img} />
          </IonRouterLink>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default PoweredBy;
